export default {
    statusPill: {
        draft: 'Nacrt',
        validated: 'Provjereno',
        approved: 'Odobreno',
        locked: 'Zaključano 🔒',
        cancelled: 'Otkazano',
    },
}
